class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.selector = this.getAttribute('selector') || '.mega-dropdown';
    this.breakpoint = parseInt(this.getAttribute('breakpoint')) || 992;

    this.dropdowns = [];
    this.isDesktop = window.matchMedia(`(min-width: ${this.breakpoint}px)`);

    this._listeners = [];
  }

  connectedCallback() {
    this.dropdowns = document.querySelectorAll(this.selector);
    if (!this.dropdowns.length) return;
    this.init();
  }

  disconnectedCallback() {
    this._listeners.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler);
    });
    this._listeners = [];

    this.dropdowns = [];
  }

  init() {
    if (this.isDesktop.matches) {
      this.enableHoverMode();
    } else {
      this.enableClickMode();
    }

    const onMediaChange = (e) => {
      if (e.matches) {
        this.disableClickMode();
        this.enableHoverMode();
      } else {
        this.disableHoverMode();
        this.enableClickMode();
      }
    };

    this.isDesktop.addEventListener('change', onMediaChange);
    this._listeners.push({ element: this.isDesktop, event: 'change', handler: onMediaChange });
  }

  enableHoverMode() {
    this.dropdowns.forEach((drop) => {
      const toggle = drop.querySelector(".dropdown-toggle");
      const menu = drop.querySelector(".dropdown-menu");
      if (!toggle || !menu) return;

      const onEnter = () => {
        drop.classList.add("show");
        toggle.classList.add("show");
        menu.classList.add("show");
      };

      const onLeave = () => {
        drop.classList.remove("show");
        toggle.classList.remove("show");
        menu.classList.remove("show");
      };

      const onClick = (e) => {
        const alreadyOpen = drop.classList.contains("show");
        if (!alreadyOpen) {
          e.preventDefault();
          drop.classList.add("show");
          toggle.classList.add("show");
          menu.classList.add("show");
        } else {
          drop.classList.remove("show");
          toggle.classList.remove("show");
          menu.classList.remove("show");
          window.location.href = toggle.getAttribute("href");
        }
      };

      drop.addEventListener("mouseenter", onEnter);
      drop.addEventListener("mouseleave", onLeave);
      toggle.addEventListener("click", onClick);

      this._listeners.push({ element: drop, event: "mouseenter", handler: onEnter });
      this._listeners.push({ element: drop, event: "mouseleave", handler: onLeave });
      this._listeners.push({ element: toggle, event: "click", handler: onClick });
    });
  }

  disableHoverMode() {
    this.dropdowns.forEach((drop) => {
      const newDrop = drop.cloneNode(true);
      drop.parentNode.replaceChild(newDrop, drop);
    });
  }

  enableClickMode() {
    this.dropdowns.forEach((drop) => {
      const toggle = drop.querySelector('.dropdown-toggle');
      const menu = drop.querySelector('.dropdown-menu');
      if (!toggle || !menu) return;

      const onToggleClick = (e) => {
        e.preventDefault();
        const isOpen = drop.classList.contains('show');
        this.closeAllMenus();
        if (!isOpen) {
          drop.classList.add('show');
          toggle.classList.add('show');
          menu.classList.add('show');
        }
      };

      toggle.addEventListener('click', onToggleClick);
      this._listeners.push({ element: toggle, event: 'click', handler: onToggleClick });
    });

    const onDocClick = (e) => {
      if (!e.target.closest(this.selector)) {
        this.closeAllMenus();
      }
    };

    document.addEventListener('click', onDocClick);
    this._listeners.push({ element: document, event: 'click', handler: onDocClick });
  }

  disableClickMode() {
    this._listeners = this._listeners.filter(({ element, event, handler }) => {
      const shouldKeep = !(event === 'click' && (element === document || element.matches?.('.dropdown-toggle')));
      if (!shouldKeep) element.removeEventListener(event, handler);
      return shouldKeep;
    });
  }

  closeAllMenus() {
    this.dropdowns.forEach((drop) => {
      drop.classList.remove('show');
      const toggle = drop.querySelector('.dropdown-toggle');
      const menu = drop.querySelector('.dropdown-menu');
      if (toggle) toggle.classList.remove('show');
      if (menu) menu.classList.remove('show');
    });
  }
}

customElements.define('mega-menu', MegaMenu);
